function onClickAndHold(fn: () => void) {
  fn();
  const id: { interval?: number; timeout?: number } = {};
  const handleMouseUp = () => {
    window.clearTimeout(id.timeout);
    window.clearInterval(id.interval);
    document.removeEventListener('mouseup', handleMouseUp, false);
  };
  document.addEventListener('mouseup', handleMouseUp, false);
  id.timeout = window.setTimeout(() => {
    id.interval = window.setInterval(fn, 30);
  }, 500);
}

export default onClickAndHold;
